import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "meetOwnerFilled"
const MeetOwnerFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6 14.438C6.517 14.438 6.937 14.858 6.937 15.375V21.375C6.937 21.893 6.517 22.313 6 22.313H4.125C3.607 22.313 3.187 21.893 3.187 21.375V15.375C3.187 14.857 3.607 14.438 4.125 14.438zM12.375 14.438C13.603 14.438 14.644 15.225 15.026 16.323L14.912 16.395C14.132 16.832 13.252 17.063 12.358 17.063H11.999C11.69 17.063 11.438 17.315 11.438 17.625S11.689 18.187 12 18.188H12.358C13.448 18.188 14.52 17.906 15.472 17.372L15.482 17.366 15.495 17.359 19.122 15.1C19.649 14.77 20.275 14.7 20.839 14.869 21.082 15.005 21.302 15.19 21.468 15.439 21.806 15.945 21.766 16.521 21.604 16.982 21.442 17.442 21.138 17.862 20.809 18.168L18.164 20.624C16.995 21.709 15.458 22.313 13.863 22.313H12.94C12.009 22.313 11.083 22.162 10.198 21.867L8.063 21.154V15.403L9.24 14.814C9.734 14.567 10.28 14.437 10.833 14.437z" />
          <path
            fillRule="evenodd"
            d="M16.5 2.25C19.399 2.25 21.75 4.6 21.75 7.5 21.75 10.127 19.82 12.304 17.3 12.69Q16.907 12.75 16.5 12.75C15.865 12.75 15.257 12.637 14.694 12.431Q14.453 12.344 14.224 12.232C13.61 11.937 13.064 11.527 12.613 11.03Q12.443 10.844 12.291 10.641 12.045 10.308 11.85 9.938H11.25V8.625H9.75V9.938H8.25V8.625H6.75V9.938H4.81L4.754 9.87 3.264 8.104C2.97 7.755 2.97 7.244 3.265 6.896L4.755 5.129 4.81 5.063H11.85C12.372 4.066 13.206 3.258 14.222 2.768Q14.453 2.658 14.694 2.568C15.257 2.363 15.865 2.25 16.5 2.25M18 6C17.172 6 16.5 6.672 16.5 7.5S17.172 9 18 9 19.5 8.328 19.5 7.5 18.828 6 18 6"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default MeetOwnerFilledIcon
